// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3w---","unreadBadge":"styles_unreadBadge__AlGPc","modalContent":"styles_modalContent__4gy0s","modal":"styles_modal__1L4Pd"};